export default "__VITE_ASSET__CuIStXwK__"